const SENSITIVE_KEYS = [
  'password',
  'newpassword',
  'token',
  'accesstoken',
  'refreshtoken',
  'authorization',
  'apikey',
  'code',
  'otp',
  'totp',
  'secret',
  'setupkey',
  'phone',
  'email',
];

const REDACTED = '[redacted]';

const MAX_DEPTH = 4;

const normalizeKey = (key: string) => key.toLowerCase().replace(/[_-]/g, '');

const isSensitive = (key: string) => SENSITIVE_KEYS.includes(normalizeKey(key));

const redact = (value: unknown, depth = 0): unknown => {
  if (depth > MAX_DEPTH || value === null || typeof value !== 'object') {
    return value;
  }

  if (Array.isArray(value)) {
    return value.map(item => redact(item, depth + 1));
  }

  const result: Record<string, unknown> = {};

  Object.entries(value as Record<string, unknown>).forEach(([key, item]) => {
    result[key] = isSensitive(key) ? REDACTED : redact(item, depth + 1);
  });

  return result;
};

export {
  redact,
};
